import React from 'react'
import './HeroImage.scss'
import { graphql, useStaticQuery } from 'gatsby'
import {GatsbyImage, getImage} from "gatsby-plugin-image";

export default function HeroImage(props) {

    const data = useStaticQuery(graphql`
      query {
        blog: file(relativePath: { eq: "blog-hero-as-202307290.png" }) {
          childImageSharp {
            gatsbyImageData(width: 1400)
          }
        }
        video: file(relativePath: { eq: "video-hero-as-291369719.jpg" }) {
          childImageSharp {
            gatsbyImageData(width: 1400)
          }
        }
      }
    `)

    const src = props.layoutContext == 'post' ? getImage(data.blog.childImageSharp) : getImage(data.video.childImageSharp)
    return (
      <div className="hero-image--wrapper single-image">
        <div className="hero-image"><GatsbyImage image={src} alt={props.layoutContext} /></div>
      </div>
    )
  }
